export default __webpack_public_path__ + "static/media/verifyEmail.cd30b736.jpg";